module.exports = __webpack_public_path__ + "static/img/slogan.d354941.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index1/slogan.png
// module id = e5zT
// module chunks = 7